import { format } from 'date-fns';

export default class FilterHelper {
	static formatFilter = (values) => {
		if (!values) {
			return null;
		}

		if (typeof values == 'object') {
			Object.keys(values).forEach((key) => {
				if (
					values[key] === undefined ||
					values[key] === null ||
					values[key] === ''
				) {
					delete values[key];
				}
			});

			return values;
		}
	};

	static mapToParams = (values = '', addFilterKey = false) => {
		let params = '';
		if (values) {
			let filterData = values?.split(',');
			filterData.forEach((resp) => {
				if (resp && resp.split('=')[1]) {
					params = params.concat(
						`&${addFilterKey ? 'filter.' : ''}${resp.split('=')[0]
						}=${encodeURIComponent(resp.split('=')[1])}`
					);
				}
			});
		}
		return params;
	};

	static mapFilters = (queryParameters) => {
		let filters = [];
		if (queryParameters.length) {
			return null;
		}
		queryParameters.forEach((value, key) => {
			if (key === 'currentPage' || key === 'perPage') {
				return;
			}
			filters.push(`${key}=${value}`);
		});
		return filters.toString();
	};

	static getTransactionDefaultFilter(filter) {
		const d = new Date();
		d.setMonth(d.getMonth() - 3);
		return {
			startDate:
				FilterHelper.mapFilterStringToForm(filter, 'startDate') ||
				format(d, 'MM/dd/yyyy'),
			endDate:
				FilterHelper.mapFilterStringToForm(filter, 'endDate') ||
				format(new Date(), 'MM/dd/yyyy'),
			amount: FilterHelper.mapFilterStringToForm(filter, 'amount') || '',
			comment: FilterHelper.mapFilterStringToForm(filter, 'comment') || '',
			email: FilterHelper.mapFilterStringToForm(filter, 'email') || '',
			isConfirmed:
				FilterHelper.mapFilterStringToForm(filter, 'isConfirmed') === 'true'
					? true
					: FilterHelper.mapFilterStringToForm(filter, 'isConfirmed') ===
						'false'
						? false
						: null,
		};
	}

	static getAECBFilter() {
		const d = new Date();
		d.setMonth(d.getMonth() - 3);
		return {
			startDate: format(d, 'MM/dd/yyyy'),
			endDate: format(new Date(), 'MM/dd/yyyy'),
		};
	}

	static getApprovedInvestorFilter() {
		return {
			approvedFrom: '',
			approvedTo: '',
		};
	}

	static getCRSDataFilter() {
		return {
			snapshotDate: format(new Date(), 'MM-dd-yyyy'),
		};
	}

	static MapLenderSums(lenderList) {
		return {
			portfolioTotalSum: lenderList?.portfolioTotalSum || 0,
			investedAmountSum: lenderList?.investedAmountSum || 0,
			reservedSum: lenderList?.reservedSum || 0,
			availableCashSum: lenderList?.availableCashSum || 0,
			netYieldSum: lenderList?.netYieldSum || 0,
			currentYearDepositsSum: lenderList?.currentYearDepositsSum || 0,
		};
	}

	static checkMuliSelectValues(values) {
		let formattedValues = '';
		Object.keys(values).forEach((key) => {
			let filterValues = values[key];
			if (filterValues instanceof Array && filterValues?.length) {
				filterValues.forEach((resp) => {
					formattedValues = formattedValues.concat(`${key}=${resp},`);
				});
			} else {
				let valueOfKey =
					typeof values[key] === 'boolean'
						? values[key].toString()
						: values[key];
				if (valueOfKey) {
					formattedValues = formattedValues.concat(`${key}=${values[key]},`);
				}
			}
		});
		return formattedValues;
	}
	static mapFilterStringToForm(values = '', formKey) {
		if (values && values.length) {
			let valueArray = values.split(',');
			return this.getValueFormSameKey(valueArray, formKey);
		}
		return '';
	}

	static getValueFormSameKey(valueArray = [], key) {
		let values = [];
		let multiValues = valueArray.filter((resp) => resp.split('=')[0] === key);
		if (multiValues.length) {
			multiValues.forEach((resp) => {
				values.push(resp.split('=')[1]);
			});
		}
		return values?.length ? values.toString() : undefined;
	}
}
